import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7de164fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h2 data-v-7de164fe>一句话识别Restful API</h2><h4 style=\"margin-top:2rem;\" data-v-7de164fe>功能介绍</h4><p style=\"margin-top:2rem;\" data-v-7de164fe>对时长较短（一分钟以内）的语音进行识别，适用于智能外呼、智能客服等较短的语音交互场景中。 <strong data-v-7de164fe>针对8K电话语音场景的识别。</strong></p><h4 style=\"margin-top:2rem;\" data-v-7de164fe>音频要求</h4><ul style=\"margin-top:2rem;\" data-v-7de164fe><li data-v-7de164fe><p data-v-7de164fe>时长限制：60s以内</p></li><li data-v-7de164fe><p data-v-7de164fe>支持音频格式：wav pcm</p></li><li data-v-7de164fe><p data-v-7de164fe>音频采样率：8000Hz</p></li><li data-v-7de164fe><p data-v-7de164fe>采样精度（位深）：16bit</p></li><li data-v-7de164fe><p data-v-7de164fe>声道：单声道</p></li></ul><h4 style=\"margin-top:2rem;\" data-v-7de164fe>使用方法</h4><p style=\"margin-top:2rem;\" data-v-7de164fe>1. 在本网站注册账号，注册完成后即可生成可用的token</p><p data-v-7de164fe>2. 发送识别请求：按照请求说明发送请求，具体参数详见“请求参数”</p><p data-v-7de164fe>3. 接收返回结果：发送请求成功后会立即收到返回响应，按JSON格式返回，具体详见“返回说明”</p><h4 style=\"margin-top:2rem;\" data-v-7de164fe>服务地址</h4>", 10)
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"margin-top":"2rem"} }, "请求参数", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"2rem"} }, "1. 请求方式：POST", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2. 参数说明如下", -1))
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<h4 style=\"margin-top:2rem;\" data-v-7de164fe>请求示例</h4><pre style=\"margin:1rem 0;\" data-v-7de164fe>    curl http://asr.talentedsoft.com:58100/dotcasr \\\r\n    -X POST \\\r\n    -F userid=xxxxx \\\r\n    -F token=xxxxxx \\\r\n    -F file=@/wav/test.wav\r\n  </pre><p data-v-7de164fe>完整示例：</p><pre style=\"background:#f7f7f7;\" data-v-7de164fe>    curl http://asr.talentedsoft.com:58100/dotcasr -X POST -F userid=xxxxx -F token=xxxxx -F file=@/wav/test.wav\r\n  </pre><h4 style=\"margin-top:2rem;\" data-v-7de164fe>响应结果</h4><p data-v-7de164fe>成功响应： {&quot;result&quot;:&quot;语音识别结果文本内容。&quot;,&quot;errCode&quot;:&quot;0&quot;}</p><h4 style=\"margin-top:2rem;\" data-v-7de164fe>结果字段</h4>", 7)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_table, {
      data: [{ type:'外网访问', 'URL': 'http://asr.talentedsoft.com:58100/dotcasr' }],
      border: "",
      style: {"width":"100%","margin-top":"2rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "访问类型",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "URL",
          label: "URL"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _createVNode(_component_el_table, {
      data: _ctx.RequestParams,
      border: "",
      style: {"width":"100%","margin-top":"1rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "参数名称",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "isRequired",
          label: "是否必填",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "说明"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _hoisted_14,
    _createVNode(_component_el_table, {
      data: _ctx.ResponseParams,
      border: "",
      style: {"width":"100%","margin-top":"1rem","margin-bottom":"10rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "字段名",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "描述"
        })
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}